import { Injectable } from '@angular/core';
import { IModalOptions } from "../../common/modals/modal-options.interface";
import { TrainingRecordEditorModalComponent } from "../components/training-record-editor-modal/training-record-editor-modal.component";
import { ITrainingRecord } from "../../message-models/training-record.interface";
import { ITrainingType } from "../../message-models/training-record-type.interface";
import { Observable, of } from 'rxjs';
import { TrainingRecord } from '../../domain-model/training-record.class';
import { EcaModalOptions } from "../../shared/models/yesno-modal-options.class";
import { EcaDynamicModalService } from "../../shared/services/eca-dynamic-modal-service";
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IEcaDialogRef } from '../../shared/models/eca-dialog-ref.interface';

@Injectable({
  providedIn: 'root'
})

export class TrainingRecordModalService {
  modalRef: IEcaDialogRef;

  constructor(private ecaDynamicModalService: EcaDynamicModalService) { }

  openTrainingRecordEditorModal(heading: string,
    trainingTypes: ITrainingType[],
    isEditing: boolean = false,
    isMultipleOperatives: boolean = false,
    trainingRecord?: ITrainingRecord,
    options?: IModalOptions
  ): Observable<IEcaDialogRef> {
    if (options === undefined) {
      options = new EcaModalOptions();
      options.modalClasses += " modal-eca-success";
    }
    if (!trainingRecord) { trainingRecord = new TrainingRecord({} as ITrainingRecord); }

    let config = {
      styleClass: 'modal-xl ' + options.modalClasses,
      baseZIndex: 2000,
      showHeader: false,
      data: {
        heading,
        trainingTypes,
        editing: isEditing,
        trainingRecord: trainingRecord,
        isMultipleOperatives,
      }
    } as DynamicDialogConfig;
    this.modalRef = this.ecaDynamicModalService.openDialog(TrainingRecordEditorModalComponent, config);
    return of(this.modalRef);
  }
}
